module.exports = __webpack_public_path__ + "static/media/StepPass.f565e8ed.svg";